var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxPadlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1997)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_1997",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_1997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.425 3.78171L10.8661 2.12654C10.3936 1.95782 9.62276 1.95782 9.15029 2.12654L4.59146 3.78171C3.71284 4.1031 3 5.09941 3 6.00733V12.5155C3 13.1663 3.43931 14.026 3.97809 14.4117L8.53692 17.7139C9.34094 18.3005 10.6589 18.3005 11.4629 17.7139L16.0218 14.4117C16.5605 14.018 16.9999 13.1663 16.9999 12.5155V6.00733C17.0082 5.09941 16.2953 4.1031 15.425 3.78171ZM10.6257 10.7719V12.8851C10.6257 13.2145 10.3439 13.4877 10.004 13.4877C9.6642 13.4877 9.38238 13.2145 9.38238 12.8851V10.7719C8.54521 10.5148 7.93187 9.75954 7.93187 8.86768C7.93187 7.7589 8.86018 6.85902 10.004 6.85902C11.1479 6.85902 12.0763 7.7589 12.0763 8.86768C12.0763 9.76757 11.4629 10.5148 10.6257 10.7719Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxPadlock);
export default __webpack_public_path__ + "static/media/iconsax-padlock.dd612ac54ea0a8ce63485de913a0e4ad.svg";
export { ForwardRef as ReactComponent };